<div class="owl-carousel owl-theme app-carousel-container" #owlNative>
  <ng-template
    *ngFor="let item of items; let i = index"
    [ngTemplateOutlet]="compile"
    [ngTemplateOutletContext]="{$implicit: item, index: i, selectedIndex: childIndex}"
  ></ng-template>
</div>
